









import Vue from 'vue';
import {UserViewModel} from "@/models/UserViewModel";
import ConnectionListPanelMetrovan from "@/components/connections/ConnectionListPanelMetrovan.vue";
import ConnectionListPanelMunicipal from "@/components/connections/ConnectionListPanelMunicipal.vue";

export default Vue.extend( {
  name: "ConnectionList",
  components: {
    ConnectionListPanelMetrovan ,
    ConnectionListPanelMunicipal ,
  },
  data: function () {
    return {

    }
  },
  methods: {
  },
  computed: {
    loggedInUser(): UserViewModel {
      return this.$store.state.loggedInUser;
    },
  } ,
  mounted: async function () {
    // do something
  }
} )
